import { useMemo } from 'react';
import { useTexture } from '@react-three/drei';
import { DoubleSide, RingGeometry, SRGBColorSpace } from 'three';
import { Planet } from './Planet.jsx';

// RingGeometry ships angular UVs — rewrite them to polar (U = normalized radial
// distance) so a ring-strip texture maps as concentric bands (research §1 gotcha).
function makePolarRing(inner, outer, segments = 256) {
  const geo = new RingGeometry(inner, outer, segments, 1);
  const pos = geo.attributes.position;
  const uv = geo.attributes.uv;
  for (let i = 0; i < pos.count; i++) {
    const r = Math.hypot(pos.getX(i), pos.getY(i));
    uv.setXY(i, (r - inner) / (outer - inner), 0.5);
  }
  return geo;
}

export function RingedPlanet({
  map = '/assets/textures/neptune_2k.jpg',
  ringMap = '/assets/textures/ring_alpha.png',
  radius = 1,
  ringInner = 1.45,
  ringOuter = 2.35,
  ringTilt = 0.42,
  position = [0, 0, 0],
  scale = 1,
  atmosphereColor = '#6f9fd8',
  children,
}) {
  const ringTexture = useTexture(ringMap, (t) => {
    t.colorSpace = SRGBColorSpace;
    t.anisotropy = 4;
  });
  const ringGeometry = useMemo(() => makePolarRing(radius * ringInner, radius * ringOuter), [radius, ringInner, ringOuter]);

  return (
    <Planet map={map} radius={radius} position={position} scale={scale} atmosphereColor={atmosphereColor} spin={0.045}>
      <mesh geometry={ringGeometry} rotation={[Math.PI / 2 - ringTilt, 0, 0]}>
        <meshBasicMaterial map={ringTexture} color="#cfdaee" transparent side={DoubleSide} depthWrite={false} opacity={0.9} />
      </mesh>
      {children}
    </Planet>
  );
}
